import React from 'react';
import { motion } from 'framer-motion';
import { MaskedLine } from './Reveal';

function PageHero({ eyebrow, title, accent, description }) {
  return (
    <section className="bg-charcoal pt-36 pb-20 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute -top-20 right-10 w-96 h-96 rounded-full border-2 border-white"></div>
        <div className="absolute -bottom-32 left-1/4 w-64 h-64 rounded-full border-2 border-brand-red"></div>
      </div>
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="flex items-center space-x-3 mb-6"
        >
          <div className="w-10 h-0.5 bg-brand-red"></div>
          <span className="text-brand-red text-sm font-semibold tracking-[0.25em] uppercase">{eyebrow}</span>
        </motion.div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
          <MaskedLine delay={0.1}>
            {title} {accent && <span className="text-brand-red">{accent}</span>}
          </MaskedLine>
        </h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="text-gray-300 text-base md:text-lg max-w-2xl mt-6 leading-relaxed"
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}

export default PageHero;
